import { constants } from "../../../constants";

export default class UpdateBalance {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.game.updateBalance(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.EXCITE:
                event["updateBalance"] = this._default;
                event["setBalance"] = this._default;
                break;
            case constants.PLAYTECH:
                event["ucip.balancerefresh.w2gRefreshBalanceCommand"] = this._default;
                event["updateBalance"] = this._default;
                break
            case constants.POKERSTARS:
                event["xc2rgBalanceUpdated2"] = this._default;
                break;
            default:
                event["updateBalance"] = this._default;
        }

        return event;
    }
}
